module.exports = __webpack_public_path__ + "static/media/brown.5a4f92b4.png";